<template>
  <b-card>
    <EditTeamModal
      :team="tobeEditedTeam"
      @refetch="fetchTeams"
      @hidden="tobeEditedTeam = undefined"
    />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loading"
    >
      <b-row class="mb-2">
        <b-col md="4">
          <label for="external-id-filter">Search by Driver External ID</label>
          <b-form-input
            id="external-id-filter"
            v-model="queryParams.driverExternalId"
            placeholder="Driver External ID"
          />
        </b-col>
        <b-col md="4">
          <label for="driver-phone-filter">Search by Driver Phone Number</label>
          <b-form-input
            id="driver-phone-filter"
            v-model="queryParams.driverPhoneNumber"
            placeholder="Driver Phone Number"
          />
        </b-col>
        <b-col md="4">
          <ZonesSearch
            label="Search by zone"
            @zone-selected="queryParams.zone = $event"
          />
        </b-col>
        <b-col
          md="4"
          class="d-flex align-items-center my-1"
        >
          <b-button
            class="mr-2"
            variant="primary"
            @click="fetchTeams"
          >
            Search
          </b-button>
          <b-button
            variant="danger"
            @click="resetFilters"
          >
            Clear
          </b-button>
        </b-col>
      </b-row>
      <b-table
        :fields="tableColumns"
        :items="teamsList"
        striped
        hover
        responsive
        show-empty
        empty-text="No matching teams found"
      >
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="$router.push(`/teams/${data.item.id}`)">
              <feather-icon
                icon="BriefcaseIcon"
              />
              <span class="align-middle ml-50">View Details</span>
            </b-dropdown-item>
            <!-- <b-dropdown-item
              v-if="$can('delete', 'teams')"
              @click="openDeleteTeamPopup(data.item)"
            >
              <feather-icon
                icon="TrashIcon"
              />
              <span class="align-middle ml-50">Delete Team</span>
            </b-dropdown-item> -->
            <b-dropdown-item
              v-if="$can('write', 'teams')"
              @click="editTeamhandler(data.item)"
            >
              <feather-icon
                icon="EditIcon"
              />
              <span class="align-middle ml-50">Edit Team</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <base-pagination
        v-model="queryParams.page"
        :total="total"
        @new-per-page="queryParams.perPage = $event"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BOverlay,
  BButton,
  BRow,
  BCol,
  BFormInput,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import {
  reactive, ref, toRef, watch,
} from '@vue/composition-api'
import BasePagination from '@/UI/BasePagination.vue'
import axiosIns from '@/libs/axios'
import EditTeamModal from '../components/EditTeamModal.vue'
import ZonesSearch from '@/views/zones/components/ZonesSearch.vue'

export default {
  components: {
    BCard,
    BTable,
    ZonesSearch,
    BOverlay,
    EditTeamModal,
    BFormInput,
    BasePagination,
    BRow,
    BCol,
    BButton,
    BDropdown,
    BDropdownItem,
  },
  setup(_, ctx) {
    const tobeEditedTeam = ref()
    const queryParams = reactive({
      page: 1,
      perPage: 10,
      zone: undefined,
      driverPhoneNumber: undefined,
      driverExternalId: undefined,
    })
    const total = ref(0)
    const tableColumns = [
      {
        label: 'Creator',
        key: 'creator',
        formatter: (_1, _2, item) => `${item.creator.name} ${item.creator.phoneNumber}`,
      },
      {
        label: 'Name English',
        key: 'nameEn',
        formatter: (_1, _2, item) => item.name.en,
      },
      {
        label: 'Name Arabic',
        key: 'nameAr',
        formatter: (_1, _2, item) => item.name.ar,
      },
      {
        label: 'Rank',
        key: 'rankLevel',
        formatter: (_1, _2, item) => item.rank.level,
      },
      {
        label: 'Rank Capacity',
        key: 'rankCapacity',
        formatter: (_1, _2, item) => item.rank.capacity,
      },
      {
        label: 'Zone',
        key: 'zone',
        formatter: (_1, _2, item) => item?.zone?.split('::')[1],
      },
      'actions',
    ]
    const teamsList = ref([])
    const loading = ref(false)

    const fetchTeams = async () => {
      loading.value = true

      const PARAMS = { ...queryParams }
      if (queryParams.driverPhoneNumber && !queryParams.driverPhoneNumber.startsWith('+')) {
        PARAMS.driverPhoneNumber = `+${queryParams.driverPhoneNumber}`
      }
      const result = await axiosIns.get('/teams', {
        params: PARAMS,
      })
      const { total: totalTeams, teams } = result.data
      teamsList.value = teams
      total.value = totalTeams
      loading.value = false
    }
    fetchTeams()

    watch([toRef(queryParams, 'page'), toRef(queryParams, 'perPage')], () => {
      fetchTeams()
    })

    const resetFilters = () => {
      queryParams.driverExternalId = undefined
      queryParams.driverPhoneNumber = undefined
      fetchTeams()
    }

    const editTeamhandler = team => {
      tobeEditedTeam.value = JSON.parse(JSON.stringify(team))
      ctx.root.$bvModal.show('edit-team-modal')
    }

    return {
      loading,
      teamsList,
      resetFilters,
      editTeamhandler,
      tobeEditedTeam,
      tableColumns,
      queryParams,
      fetchTeams,
      total,
    }
  },
}
</script>

<style></style>
